<template>
    <div class="words-roll-page">
        <div class="title">
            <div v-for="(item, index) in titleList" class="title-item" :style="{width: item.width + '%'}" :key="index">{{item.name}}</div>
        </div>
        <div class="ad-list">
            <vue-seamless-scroll :data="adList" :class-option="classOption" class="table-content">
                <ul v-for="(item, index) in adList" :key="index" class="list">
                    <li>{{item.putInStartTime | getDate}}</li>
                    <li>{{item.programName}}</li>
                    <li>{{item.deviceNum}}</li>
                    <li>{{item.coveredPopulation}}</li>
                    <!-- <li v-for="(value, name) in item" :key="name">{{value}}</li> -->
                </ul>
            </vue-seamless-scroll>
        </div>
    </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import moment from "moment";
export default {
    name: "WordsRoll",
    components: {
        vueSeamlessScroll
    },
    props:{
        // 头部标题
        titleList: {
            type: Array,
            default(){
                // return ["上刊时间", "广告名称", "投放点位", "覆盖人群"]
                return [{
                    name: "上刊时间",
                    width: 23
                }, {
                    name: "广告名称",
                    width: 40
                }, {
                    name: "投放点位",
                    width: 20
                }, {
                    name: "覆盖人群",
                    width: 20
                }];
            }
        },
        // 数据列表
        list:{
            type: Array,
            default(){
                return [];
            }
        }
    },
    data(){
        return {
            // 广告数据
            adList:[],
        }
    },
    computed:{
        // 对滚动组件的配置
        classOption(){
            return {
                singleHeight: 136,
                step: 0.4,
                waitTime: 3000,
                limitMoveNum: 5,
                direction: 1,
                // autoPlay: false,
            }
        }
    },
    filters: {
        getDate(value){
            return moment(parseInt(value)).format("YYYY-MM-DD");
        }
    },
    watch:{
        'list':{
            immediate: true,
            handler(value){
                this.adList = value;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.words-roll-page{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .title{
        display: flex;
        align-items: center;
        .title-item{
            font-size: 14px;
            color: #f4a695;
        }
    }
    .ad-list{
        flex:1;
        padding: 13px 0px;
        overflow: hidden;
        .table-content{
            width: 100%;
            height: 100%;
            overflow: hidden;
            .list{
                display: flex;
                align-items: center;
                li{
                    font-size: 12px;
                    width:20%;
                    margin-bottom: 5px;
	                color: #b8d1d2;
                    &:nth-child(2){
                        width: 40%;
                        overflow:hidden;
                        white-space:nowrap;
                        text-overflow: ellipsis;
                    }
                    &:first-child{
                        width: 23%;
                    }
                }
            }
        }
    }
}
</style>